import {
  Box,
  Grid,
  Typography,
  Hidden,
  IconButton,
  LinearProgress,
  CardMedia,
  Chip,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { useHistory } from 'react-router';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { Gridstyles, Item, ItemDetails } from '../ApplicationDetails';
import { useDispatch } from 'react-redux';
import { KeyValue } from '../ApplicationDetails/contributor';
import { SRMType } from '../../redux-store/types/api-types';
import { getSRMById } from '../../redux-store/actions/userManagement';
import { Location } from 'history';
import { srmMappedUsersMaster } from '../../utils/constant';
import { checkApplicableForYes } from '../../utils/utilityFunctions';

export default function SRMDetails({
  location,
}: {
  location: Location<{ srmId: number }>;
}): JSX.Element {
  const { srmId: id } = location.state || { srmId: null };
  const history = useHistory();
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);
  const [srmDetails, setSRMById] = useState<SRMType>();

  useEffect(() => {
    let isComponentActive = true;
    (async function () {
      try {
        setLoading(true);
        if (id) {
          const getRmDetails = (await dispatch(getSRMById(Number(id)))) as unknown as SRMType;
          setSRMById(getRmDetails);
        }
        if (!isComponentActive) {
          return;
        }
        setLoading(false);
      } catch (e) {
        setLoading(false);
        console.log((e as Error).message);
      }
    })();
    return () => {
      isComponentActive = false;
    };
  }, []);

  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
          py: { xs: 2, sm: 5 },
          px: { xs: 0, sm: 5 },
          mt: { xs: 2, sm: 5 },
        }}>
        <Hidden smUp={true}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton
              sx={{ height: 'fit-content', p: 0 }}
              onClick={() => history.push('service-managers')}>
              <NavigateBeforeIcon fontSize="medium" sx={{ color: 'common.black' }} />
            </IconButton>
            <Typography
              sx={{
                fontSize: 20,
                fontWeight: 600,
                color: '#1C2D47',
              }}>
              Back
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              my: 2,
              py: 2,
              pl: { xs: 3, sm: 0 },
              color: 'primary.main',
              bgcolor: 'rgba(238, 244, 251, 0.5)',
            }}>
            <PersonOutlineOutlinedIcon fontSize="large" />
            <Typography
              sx={{
                fontSize: 20,
                fontWeight: 600,
                pl: 1,
              }}>
              User Management
            </Typography>
          </Box>
        </Hidden>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Hidden only="xs">
              <IconButton
                sx={{ height: 'fit-content', p: 0 }}
                onClick={() => history.push('service-managers')}>
                <NavigateBeforeIcon fontSize="medium" sx={{ color: 'common.black' }} />
              </IconButton>
            </Hidden>
            <Typography
              sx={{
                fontSize: 20,
                fontWeight: 600,
                color: '#1C2D47',
                pl: { xs: 2, sm: 0 },
              }}>
              SRM Details
            </Typography>
          </Box>
          <IconButton>
            <CardMedia
              component="img"
              src="/images/edit-icon-outlined.svg"
              alt="Edit Icon"
              sx={{ width: 'unset' }}
              onClick={() => history.push('edit-srm-details', { srmId: srmDetails?.id })}
            />
          </IconButton>
        </Box>
        {isLoading ? (
          <LinearProgress sx={{ ml: 5, mr: 5 }} />
        ) : (
          srmDetails && (
            <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 }, pt: 1 }}>
              <React.Fragment>
                <Gridstyles>
                  <Grid
                    item
                    container
                    pb={5}
                    rowSpacing={6}
                    columnSpacing={13}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start">
                    <KeyValue title={'SRM Name'} description={srmDetails.name} />
                    <KeyValue title={'SRM Email Address'} description={srmDetails.user.email} />
                    <KeyValue title={'SRM Mobile'} description={srmDetails.user.phone} />
                    <Grid item xs={12}>
                      <Item>{`Mapped Users`}</Item>
                      {srmDetails?.mappedUsers && srmDetails?.mappedUsers?.length > 0 ? (
                        <Box
                          sx={{
                            border: 0.5,

                            borderColor: 'primary.main',
                            p: 3,
                            mb: 3,
                            mt: 2,
                            borderRadius: 0.5,
                          }}>
                          {srmDetails?.mappedUsers?.map((mappedUser) => {
                            let role = '';
                            if (mappedUser?.isRia) {
                              role = checkApplicableForYes(mappedUser?.isRia)
                                ? 'ria'
                                : 'distributor';
                            } else if (mappedUser?.user?.role) {
                              role = mappedUser?.user?.role;
                            }
                            return (
                              <React.Fragment key={mappedUser.id}>
                                <Chip
                                  label={`${mappedUser?.name} (${
                                    mappedUser?.type ? mappedUser?.type + ' ' : ''
                                  }${srmMappedUsersMaster[role || '']})`}
                                  sx={{
                                    fontSize: 14,
                                    fontWeight: 500,
                                    color: 'rgba(41, 49, 57, 0.7)',
                                    m: 0.8,
                                  }}
                                />
                              </React.Fragment>
                            );
                          })}
                        </Box>
                      ) : (
                        <ItemDetails>-</ItemDetails>
                      )}
                    </Grid>
                  </Grid>
                </Gridstyles>
              </React.Fragment>
            </Grid>
          )
        )}
      </Box>
    </>
  );
}
